import React from "react";
import {
  Box,
  Typography,
  Grid,
  styled,
} from "@mui/material";
import { 
  Ticket as TicketIcon, 
  Clock, 
  CheckCircle2, 
  Users, 
  Briefcase 
} from "lucide-react";

const StatCard = styled(Box)(({ theme }) => ({
  background: 'rgba(255, 255, 255, 0.95)',
  backdropFilter: 'blur(12px)',
  borderRadius: '20px',
  boxShadow: '0 1px 3px rgba(0, 0, 0, 0.04), 0 1px 2px rgba(0, 0, 0, 0.02)',
  border: '1px solid #F0F0F5',
  padding: '20px',
  transition: 'all 0.3s ease',
  height: '100%',
  '&:hover': {
    boxShadow: '0 8px 30px rgba(0, 0, 0, 0.06)',
    transform: 'translateY(-2px)',
  },
}));

const IconWrapper = styled(Box)(({ color }) => ({
  width: '40px',
  height: '40px',
  borderRadius: '12px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: `${color}15`,
  color: color,
  marginBottom: '16px',
}));

export default function TicketCards({ stats }) {
  const cards = [
    { title: "All Tickets", value: stats?.all || 0, icon: <TicketIcon size={20} />, color: "#6366F1" },
    { title: "Pending", value: stats?.pending || 0, icon: <Clock size={20} />, color: "#F59E0B" },
    { title: "Resolved", value: stats?.resolved || 0, icon: <CheckCircle2 size={20} />, color: "#10B981" },
    { title: "Agents", value: stats?.agents || 0, icon: <Users size={20} />, color: "#8B5CF6" },
    { title: "Clients", value: stats?.clients || 0, icon: <Briefcase size={20} />, color: "#EC4899" },
  ];

  return (
    <Grid container spacing={2}>
      {cards.map((card, index) => (
        <Grid item xs={12} sm={6} md={2.4} key={index}>
          <StatCard>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
              <Box>
                <Typography color="#6B7280" variant="caption" fontWeight={600} sx={{ textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                  {card.title}
                </Typography>
                <Typography variant="h4" sx={{ fontWeight: 800, color: "#111827", mt: 0.5 }}>
                  {card.value}
                </Typography>
              </Box>
              <IconWrapper color={card.color}>
                {card.icon}
              </IconWrapper>
            </Box>
          </StatCard>
        </Grid>
      ))}
    </Grid>
  );
}
